/**
 * @file   src\mobile\pages\InventoryIntroductions.js
 * @brief  This file is responsible for introductions view
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect } from "react";
import "react-swipeable-list/dist/styles.css";
import { getUserId, setLocalStorage } from "../../../helpers/common";
import { updateIntroduction } from "../../../helpers/message";
import { useNavigate, useLocation } from "react-router-dom";
import { pageURLs } from "../../../constants/pageURLs";
import {
  getMyAcceptedIntroductionByInvId,
  getMyPendingIntroductionByInvId,
  cancelIntroduction,
  getIntroductionWantAdDetailsByIntroId,
} from "../../../services/introductionService";
import { usePrevious } from "../../../hooks/usePrevious";
import IntroductionData from "../../components/InventoryIntroduction/IntroductionData";
import { toast } from "react-toastify";
import { WANT_AD_KEY } from "../../../constants/common";

const InventoryIntroductions = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const inventoryId = location.state && location.state["inventoryId"];
  const [pendingList, setPendingList] = useState([]);
  const [acceptedList, setAcceptedList] = useState([]);
  const [pendingListPage, setPendingListPage] = useState(1);
  const [acceptedListPage, setAcceptedListPage] = useState(1);
  const [pendingListCount, setPendingCount] = useState(0);
  const [acceptedListCount, setAcceptedCount] = useState(0);
  const prevPending = usePrevious(pendingListPage);
  const prevAccepted = usePrevious(acceptedListPage);
  const INTRO_LIST_PAGE_LIMIT = 4;
  const [wantAdViewInventoryId, setWantAdViewInventoryId] = useState(0);
  const [uiKey, setUIKey] = useState(null);
  const [introductionId, setIntroductionId] = useState(null);
  useEffect(() => {
    if (!inventoryId) {
      navigate(pageURLs.mobileHome);
    }
    const userId = getUserId();
    if (!prevPending && !prevAccepted) {
      getPendingIntroductions(pendingListPage, inventoryId, userId);
      getAcceptdIntroductions(acceptedListPage, inventoryId, userId);
    } else if (prevPending !== pendingListPage) {
      getPendingIntroductions(pendingListPage, inventoryId, userId);
    } else if (prevAccepted !== acceptedListPage) {
      getAcceptdIntroductions(acceptedListPage, inventoryId, userId);
    }
  }, [pendingListPage, acceptedListPage]);
  /**
   * To get pending introductions list
   * @param {*} page
   * @param {*} inventoryId
   * @param {*} userId
   */
  const getPendingIntroductions = async (page, inventoryId, userId) => {
    const reqPayload = {
      inventoryId: inventoryId,
      page: page,
      limit: INTRO_LIST_PAGE_LIMIT,
    };
    await getMyPendingIntroductionByInvId(reqPayload).then((response) => {
      if (response) {
        const list = _.get(response, "result.List", null);
        const count = _.get(response, "result.Count", "");
        if (response.errorCode === 0) {
          setPendingList([...pendingList, ...list]);
          setPendingCount(count);
        } else {
          console.log(`####error`);
        }
      }
    });
  };
  /**
   * To get accepted introductions list
   * @param {*} page
   * @param {*} inventoryId
   * @param {*} userId
   */
  const getAcceptdIntroductions = async (page, inventoryId, userId) => {
    const reqPayload = {
      inventoryId: inventoryId,
      page: page,
      limit: INTRO_LIST_PAGE_LIMIT,
    };
    await getMyAcceptedIntroductionByInvId(reqPayload).then((response) => {
      if (response) {
        const list = _.get(response, "result.List", null);
        const count = _.get(response, "result.Count", "");
        if (response.errorCode === 0) {
          setAcceptedList([...acceptedList, ...list]);
          setAcceptedCount(count);
        } else {
          console.log(`####error`);
        }
      }
    });
  };
  const [wantAdDetails, setWantAdDetails] = useState([]);

  /**
   * To handle view want ad
   * @param {*} introductionId
   */
  const ViewWantAd = async (introductionId) => {
    setWantAdViewInventoryId(introductionId);
    const reqPayload = {
      introductionId: introductionId,
    };
    await getIntroductionWantAdDetailsByIntroId(reqPayload).then((response) => {
      if (response) {
        if (response.errorCode == 0) {
          setWantAdDetails(response.result);
          setLocalStorage(WANT_AD_KEY, {
            wantAdId: response.result[0].Want_ad_Id,
          });
          const slug = _.get(response.result[0], "slug");
          navigate(`${pageURLs.viewAd}/${slug}`, {
            state: { isFromInventory: true },
          });
        } else {
          console.log(`####error`);
        }
      }
    });
  };
  /**
   * To handle cancel introduction
   * @param {*} introductionId
   */
  const onClickCancelIntroduction = async (introductionId) => {
    const reqPayload = {
      introductionId: introductionId,
    };
    await cancelIntroduction(reqPayload).then(async (response) => {
      if (response) {
        if (response.errorCode == 0) {
          let data = {
            isdeleted: true,
          };
          let updateresponse = await updateIntroduction(introductionId, data);
          toast.success(response.message);
          setPendingList((current) =>
            current.filter((lst) => lst.IntroductionId !== introductionId),
          );
        } else {
          console.log(`####error`);
        }
      }
    });
  };

  return (
    <>
      <div className="gitcha-main-wrapper my-client-wrap recieve-intorductions-wrap">
        <div className="content-wrapper">
          <div className="inner-layout-header-new bg-white ">
            <div className="review-plan-header header-brdr-btm w-100">
              <div className="signup-login-header-top signup-header-txt clearfix">
                <a
                  className="back-link-small"
                  href={void 0}
                  onClick={() =>
                    navigate(pageURLs.mobilememberInventoryDetails)
                  }
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.1003 5.39972C10.3932 5.69262 10.3932 6.16749 10.1003 6.46038L5.31066 11.2501H20.5C20.9142 11.2501 21.25 11.5858 21.25 12.0001C21.25 12.4143 20.9142 12.7501 20.5 12.7501H5.31066L10.1003 17.5397C10.3932 17.8326 10.3932 18.3075 10.1003 18.6004C9.80744 18.8933 9.33256 18.8933 9.03967 18.6004L2.96967 12.5304C2.82902 12.3897 2.75 12.199 2.75 12.0001C2.75 11.8011 2.82902 11.6104 2.96967 11.4697L9.03967 5.39972C9.33256 5.10683 9.80744 5.10683 10.1003 5.39972Z"
                      fill="#1B1C1E"
                    />
                  </svg>
                </a>
                <span>All introductions </span>
              </div>
            </div>
          </div>
          <div className="inner-layout-content-new h-100 ">
            <div className="notif-content-wrapper">
              <div className="wantad-sec">
                {pendingList.length > 0 && (
                  <div className="wantad-list">
                    <div className="title">Pending ({pendingList.length})</div>
                    {pendingList.map((intro) => {
                      const introId = _.get(intro, "IntroductionId", "");
                      return (
                        <div className="add-your-property-wrap add-property-col-direction bg-white notif-brdr">
                          <div className="dot-indicator dot-bg-red m-0"></div>
                          <div className="add-property-inner">
                            <div className="pending-intro-img flex-shrink-0">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 2.50781C11.4257 2.50781 10.8515 2.69464 10.377 3.06836H10.376L4.42969 7.75488C3.52791 8.46557 3 9.55149 3 10.7002V19.7441C3 20.7016 3.79252 21.4941 4.75 21.4941H19.25C20.2075 21.4941 21 20.7016 21 19.7441V10.7002C21 9.55149 20.4721 8.46557 19.5703 7.75488L19.5 7.69824V3.75C19.5 3.55109 19.421 3.36034 19.2803 3.21969C19.1397 3.07904 18.9489 3.00002 18.75 3H16.25C16.0511 3.00002 15.8603 3.07904 15.7197 3.21969C15.579 3.36034 15.5 3.55109 15.5 3.75V4.54688L13.623 3.06836C13.1485 2.69464 12.5743 2.50781 12 2.50781ZM12 4.00391C12.2449 4.00391 12.4899 4.08529 12.6953 4.24707L15.7861 6.68164C15.8967 6.76865 16.0296 6.82279 16.1695 6.83789C16.3094 6.85298 16.4507 6.82842 16.5773 6.767C16.7039 6.70558 16.8107 6.60979 16.8854 6.49056C16.9602 6.37134 16.9999 6.23349 17 6.09277V4.5H18V8.0625C18.0001 8.1759 18.0259 8.2878 18.0754 8.3898C18.125 8.4918 18.197 8.58123 18.2861 8.65137L18.6426 8.93262C19.1848 9.35993 19.5 10.0099 19.5 10.7002V19.7441C19.5 19.8917 19.3975 19.9941 19.25 19.9941H4.75C4.60248 19.9941 4.5 19.8917 4.5 19.7441V10.7002C4.5 10.0099 4.8152 9.35993 5.35742 8.93262L11.3047 4.24707C11.5101 4.08529 11.7551 4.00391 12 4.00391ZM7.25 11.9941C7.05109 11.9942 6.86034 12.0732 6.71969 12.2138C6.57904 12.3545 6.50002 12.5452 6.5 12.7441V16.7441C6.50002 16.943 6.57904 17.1338 6.71969 17.2744C6.86034 17.4151 7.05109 17.4941 7.25 17.4941H10.25C10.4489 17.4941 10.6397 17.4151 10.7803 17.2744C10.921 17.1338 11 16.943 11 16.7441V12.7441C11 12.5452 10.921 12.3545 10.7803 12.2138C10.6397 12.0732 10.4489 11.9942 10.25 11.9941H7.25ZM13.75 11.9941C13.5511 11.9942 13.3603 12.0732 13.2197 12.2138C13.079 12.3545 13 12.5452 13 12.7441V16.7441C13 16.943 13.079 17.1338 13.2197 17.2744C13.3603 17.4151 13.5511 17.4941 13.75 17.4941H16.75C16.9489 17.4941 17.1397 17.4151 17.2803 17.2744C17.421 17.1338 17.5 16.943 17.5 16.7441V12.7441C17.5 12.5452 17.421 12.3545 17.2803 12.2138C17.1397 12.0732 16.9489 11.9942 16.75 11.9941H13.75ZM8 13.4941H9.5V15.9941H8V13.4941ZM14.5 13.4941H16V15.9941H14.5V13.4941Z"
                                  fill="#007EF5"
                                />
                              </svg>
                            </div>

                            <IntroductionData introDetails={intro} />
                          </div>
                          <div className="intro-btn-wrap intro-btn-alignment intro-btn-topmargin">
                            <button
                              type="button"
                              className="btn btn-secondary cancel-btn-view me-2"
                              onClick={() => {
                                onClickCancelIntroduction(introId);
                              }}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary small-btn-view"
                              onClick={() => {
                                ViewWantAd(introId);
                              }}
                            >
                              View
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
                {acceptedListCount > 0 && (
                  <div className="wantad-list">
                    <div className="title">
                      Accepted ({acceptedList.length}){" "}
                    </div>
                    {acceptedList.map((intro) => {
                      const introId = _.get(intro, "IntroductionId", "");

                      return (
                        <div
                          className="add-your-property-wrap add-property-col-direction bg-white notif-brdr"
                          onClick={() => {
                            _.get(intro, "IsExpired", "") != 1 &&
                              setUIKey("ManageIntroduction");
                            setIntroductionId(introId);
                          }}
                          role="button"
                          onKeyDown={() => {
                            _.get(intro, "IsExpired", "") != 1 &&
                              setUIKey("ManageIntroduction");
                            setIntroductionId(introId);
                          }}
                        >
                          <div className="add-property-inner">
                            <div className="pending-intro-img flex-shrink-0">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 2.50781C11.4257 2.50781 10.8515 2.69464 10.377 3.06836H10.376L4.42969 7.75488C3.52791 8.46557 3 9.55149 3 10.7002V19.7441C3 20.7016 3.79252 21.4941 4.75 21.4941H19.25C20.2075 21.4941 21 20.7016 21 19.7441V10.7002C21 9.55149 20.4721 8.46557 19.5703 7.75488L19.5 7.69824V3.75C19.5 3.55109 19.421 3.36034 19.2803 3.21969C19.1397 3.07904 18.9489 3.00002 18.75 3H16.25C16.0511 3.00002 15.8603 3.07904 15.7197 3.21969C15.579 3.36034 15.5 3.55109 15.5 3.75V4.54688L13.623 3.06836C13.1485 2.69464 12.5743 2.50781 12 2.50781ZM12 4.00391C12.2449 4.00391 12.4899 4.08529 12.6953 4.24707L15.7861 6.68164C15.8967 6.76865 16.0296 6.82279 16.1695 6.83789C16.3094 6.85298 16.4507 6.82842 16.5773 6.767C16.7039 6.70558 16.8107 6.60979 16.8854 6.49056C16.9602 6.37134 16.9999 6.23349 17 6.09277V4.5H18V8.0625C18.0001 8.1759 18.0259 8.2878 18.0754 8.3898C18.125 8.4918 18.197 8.58123 18.2861 8.65137L18.6426 8.93262C19.1848 9.35993 19.5 10.0099 19.5 10.7002V19.7441C19.5 19.8917 19.3975 19.9941 19.25 19.9941H4.75C4.60248 19.9941 4.5 19.8917 4.5 19.7441V10.7002C4.5 10.0099 4.8152 9.35993 5.35742 8.93262L11.3047 4.24707C11.5101 4.08529 11.7551 4.00391 12 4.00391ZM7.25 11.9941C7.05109 11.9942 6.86034 12.0732 6.71969 12.2138C6.57904 12.3545 6.50002 12.5452 6.5 12.7441V16.7441C6.50002 16.943 6.57904 17.1338 6.71969 17.2744C6.86034 17.4151 7.05109 17.4941 7.25 17.4941H10.25C10.4489 17.4941 10.6397 17.4151 10.7803 17.2744C10.921 17.1338 11 16.943 11 16.7441V12.7441C11 12.5452 10.921 12.3545 10.7803 12.2138C10.6397 12.0732 10.4489 11.9942 10.25 11.9941H7.25ZM13.75 11.9941C13.5511 11.9942 13.3603 12.0732 13.2197 12.2138C13.079 12.3545 13 12.5452 13 12.7441V16.7441C13 16.943 13.079 17.1338 13.2197 17.2744C13.3603 17.4151 13.5511 17.4941 13.75 17.4941H16.75C16.9489 17.4941 17.1397 17.4151 17.2803 17.2744C17.421 17.1338 17.5 16.943 17.5 16.7441V12.7441C17.5 12.5452 17.421 12.3545 17.2803 12.2138C17.1397 12.0732 16.9489 11.9942 16.75 11.9941H13.75ZM8 13.4941H9.5V15.9941H8V13.4941ZM14.5 13.4941H16V15.9941H14.5V13.4941Z"
                                  fill="#007EF5"
                                />
                              </svg>
                            </div>
                            <IntroductionData introDetails={intro} />
                          </div>
                          {_.get(intro, "IsExpired", "") != 1 ? (
                            <div className="intro-btn-wrap intro-btn-alignment intro-btn-topmargin">
                              <button
                                type="button"
                                className="btn btn-primary small-btn-view"
                                onClick={() =>
                                  navigate(pageURLs.mobileMessages)
                                }
                              >
                                Message
                              </button>
                            </div>
                          ) : (
                            <div className="property-action drop-pos-fix flex-shrink-0 modal-wrap-label-orange f-size-14 me-0">
                              Expired
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InventoryIntroductions;
